module.exports = __webpack_public_path__ + "img/gun-turret-gun-extension.24d6f2ec.png";